import { render, staticRenderFns } from "./AddTreatment.vue?vue&type=template&id=361ea30f&scoped=true&"
import script from "./AddTreatment.vue?vue&type=script&lang=js&"
export * from "./AddTreatment.vue?vue&type=script&lang=js&"
import style0 from "./AddTreatment.vue?vue&type=style&index=0&id=361ea30f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ea30f",
  null
  
)

export default component.exports